interface IPlay {
  onClick?: () => void;
  width?: number;
  height?: number;
  color?: string;
}

export const Play = ({ onClick, width = 27, height = 31, color = 'black' }: IPlay) => {
  return (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      data-qa="play_icon"
      aria-label="play"
      viewBox="0 0 27 31"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27 15.5L0.749999 30.6554L0.75 0.344555L27 15.5Z" fill={color} />
    </svg>
  );
};
